var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.parent_count > 0)?_c('b-rating',{staticClass:"mr-2",attrs:{"icons":_vm.parent_icons,"score":_vm.parent_rating}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }